export const ENDPOINTS = {
  // Companies
  COMPANIES: '/companies',
  COMPANY: (id: string) => `/companies/${id}`,

  // Users
  USERS: '/users',
  USER: (id: string) => `/users/${id}`,
  USER_INVITE: (id: string) => `/users/${id}/invite`,
  AUTH_ME: '/auth/me',

  // Projects
  PROJECTS: '/projects',
  PROJECT: (id: string) => `/projects/${id}`,
  COMPANY_PROJECT: (companyId: string) => `/projects/company/${companyId}`,
  PROJECT_FIELDS: (id: string) => `/projects/${id}/fields`,
  PROJECT_CARRIER_MAPPINGS: (id: string) => `/projects/${id}/carrier-mappings`,

  // Shipments
  SHIPMENTS: '/shipments',
  SHIPMENTS_BULK: '/shipments/bulk',
  SHIPMENT: (id: string) => `/shipments/${id}`,
  SHIPMENT_CUSTOM_FIELDS: (id: string) => `/shipments/${id}/custom-fields`,
  SHIPMENT_EVENTS: (id: string) => `cargo-events/shipments/${id}/events`,
  PROJECT_SHIPMENTS: (projectId: string) => `/shipments/project/${projectId}`,
  PROJECT_SHIPMENTS_STATS: (projectId: string) => `/shipments/project/${projectId}/processing-stats`,
  PROJECT_SHIPMENTS_CUSTOM_FIELDS: (projectId: string, fieldKey: string) =>
    `shipments/project/${projectId}/custom-fields/${fieldKey}/values`,

  // Tracking Jobs
  TRACKING_JOBS: '/tracking-jobs',
  TRACKING_JOBS_BULK: '/tracking-jobs/bulk',
  TRACKING_JOB: (id: string) => `/tracking-jobs/${id}`,
  TRACKING_JOB_SHIPMENT: (shipmentId: string) => `/tracking-jobs/shipment/${shipmentId}`,
  TRACKING_JOB_RESUME: (id: string) => `/tracking-jobs/${id}/resume`,
  TRACKING_JOB_EXECUTE: (id: string) => `/tracking-jobs/${id}/execute`,

  // Files
  FILES: '/files',
  FILE: (id: string) => `/files/${id}`,
  FILE_UPLOAD_URL: '/files/upload-url',
  FILE_PROCESS: (id: string) => `/files/${id}/process`,
  PROJECT_FILE_STATS: (projectId: string) => `/files/project/${projectId}/stats`,

  // Share Links
  SHARE_LINKS: '/share-links',
  SHARE_LINK: (id: string) => `/share-links/${id}`,

  // Marine Data
  MARINE_SHIPS_AREA: '/marine-data/ships/area',
  MARINE_SHIP_POI_EVENTS: (shipId: number) => `/marine-data/ships/${shipId}/poi-events`,
  MARINE_SHIP_VISITS: (shipId: number) => `/marine-data/ships/${shipId}/visits`,
  MARINE_SHIP_PORT_EVENTS: (shipId: number) => `/marine-data/ships/${shipId}/port-events`,
  MARINE_SHIP_POSITION_HISTORY: (shipId: number) => `/marine-data/ships/${shipId}/position-history`,
  MARINE_SHIP_LATEST_POSITION: (imo: number) => `/marine-data/ships/${imo}/latest-position`,
  MARINE_POIS_AREA: '/marine-data/pois/area',

  // Search
  SEARCH_SERVICES: '/search/services',
  SEARCH_PATH: '/search/path',

  // Carriers
  CARRIERS: '/carriers',
  CARRIER_INTEGRATIONS: 'carrier-integrations',
  CARRIER_INTEGRATION: (id: string) => `/carrier-integrations/${id}`,
} as const;
